import script from "./withdrawalInfoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawalInfoPopup.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawalInfoPopup.vue?vue&type=style&index=0&id=6e43cb1a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e43cb1a"]])

export default __exports__